import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import './styles/design-system.css'  // Import design system
import 'leaflet/dist/leaflet.css'
import 'mapbox-gl/dist/mapbox-gl.css'
import ErrorBoundary from './utils/errorBoundary'
import LoadingFallback from './components/LoadingFallback'

// Initialize performance monitoring
import { preloadCriticalResources } from './utils/performanceOptimization'
import { applyBrowserFixes } from './utils/crossBrowserUtils'

// Initialize analytics if not in development mode
import { initializeGA, hasOptedOutGA } from './utils/analytics'
if (!import.meta.env.DEV && !hasOptedOutGA()) {
  initializeGA(import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX');
}

// Preload critical resources
preloadCriticalResources();

// Apply browser-specific fixes
applyBrowserFixes();

// Measure page load performance
if (import.meta.env.DEV) {
  const startTime = performance.now();
  window.addEventListener('load', () => {
    const loadTime = performance.now() - startTime;
    console.log(`Page fully loaded in ${Math.round(loadTime)}ms`);
  });
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary fallback={<LoadingFallback />}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
)